function setEnv(env: 'production' | 'development') {
  process.env.NODE_ENV = env;
}

export function resetEnv(): void {
  // only `undefined` NODE_ENV can be overridden by .env file
  // so empty string is not a reset state, but `undefined` is
  delete process.env.NODE_ENV;
}

export function setDevEnv(): void {
  setEnv('development');
}

export function setProdEnv(): void {
  setEnv('production');
}
